<template>
  <div
    v-if="!hide"
    class="footer"
  >
    <div class="footer-main">
      <div class="footer-left">
        Copyright 2025 ©
        <br>
        BestDealer.All Rights Reserved
      </div>
      <div class="footer-right">
        CS Center | Support@bestdealer.com Monday - Friday | AM 10:00 - PM 18:00
      </div>
    </div>
  </div>
</template>

<script setup>
const route = useRoute()
const hide = computed(() => {
  return ['search', 'featured'].includes(route.name)
})
</script>

<style scoped lang="less">
.footer {
  position: relative;
  width: 100%;
  background: url("@/assets/footer-bg.png") center;
  z-index: 99;
  margin-top: auto;

  .footer-main {
    display: flex;
    justify-content: space-between;
    align-items: end;
    height: 64px;
    margin: auto;
    padding: 0 24px;
    max-width: 1920PX;

    .footer-left {
      font-size: 11px;
      font-family: mon-500;
      color: #DBEFF9;
      line-height: 16px;
      margin-bottom: 14px;
    }

    .footer-right {
      font-size: 11px;
      font-family: mon-500;
      color: #DBEFF9;
      line-height: 16px;
      margin-bottom: 14px;
    }
  }
}
</style>
